import React from "react";
import { Select, Tooltip } from "antd";
import { SelectTab } from "./style";
import { connect } from "react-redux";

const Option = Select.Option;

class MultiSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      size: "large",
      value: [],
      children: this.props.menu,
      optionsAnt: [],
      optionInfo: ["A", "B", "C", "D", "E", "F"],
      info: false
    };
    this.OptionInfoHandler = this.OptionInfoHandler.bind(this);
    this.configureOptions = this.configureOptions.bind(this);
  }

  OptionInfoHandler(index) {
    this.setState({ info: true });
  }

  configureOptions = () => {
    let optionsAnt = [];
    optionsAnt = this.props.options;
    let newOption =
      optionsAnt &&
      optionsAnt.map((x, index) => (
        <Option key={index} value={x}>
          <Tooltip placement="bottomRight"> {x} </Tooltip>
        </Option>
      ));
    return newOption;
  };

  handleSelect(value) {
    this.setState({ value });
    this.props.handleDropper(value);
  }

  componentDidMount() {
    [...document.querySelectorAll(".ant-select-search__field")].forEach((item) => (
      item.setAttribute("aria-label","multi select")
    ))
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tab !== this.props.tab) {
      this.setState({ value: [] });
    }
  }
  componentWillUnmount() {
    this.setState({ value: [] });
  }

  render() {
    const { placeholder } = this.props;
    return (
      <div>
        <SelectTab
          data-test="select-component"
          id={this.props && this.props.id && this.props.id}
          mode="multiple"
          getPopupContainer={trigger => trigger.parentNode}
          placeholder={placeholder}
          value={this.state.value}
          defaultValue={[]}
          aria-label="Select Tab"
          showArrow={true}
          onChange={value => {
            this.handleSelect(value);
          }}
          style={{}}
        >
          {this.configureOptions()}
        </SelectTab>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  updatedMenu: state.getIn(["grantsActivityReducer", "menu"])
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultiSelect);
